import api from './api';

export const fetchGroupMembers = (customerId) =>
  api.get(`/customers/${customerId}/group-members`).then((r) => r.data);

export const validateGroupMembers = (customerId) =>
  api.post(`/customers/${customerId}/group-members/validate`).then((r) => r.data);

export const setCustomerInstance = (customerId, instance_name, force = false) =>
  api.put(`/customers/${customerId}/instance-name`, { instance_name, force }).then((r) => r.data);
